/**
 * SocialLinks — small icon row used in MarketingNav + MarketingFooter.
 *
 * Single source of truth: change the handles or platforms here, and every
 * surface (nav, footer, future about-page) updates together. SVG icons are
 * inlined so we don't pull in @fortawesome or @react-icons just for five
 * platforms — keeps the bundle slim.
 *
 * Handles per the founder (Feb 2026):
 *   X (Twitter):  https://x.com/BloqVideo
 *   Facebook:     https://facebook.com/BloqVideo
 *   LinkedIn:     https://linkedin.com/company/BloqVideo  (company page)
 *   YouTube:      https://youtube.com/@BloqVideo
 *   Instagram:    https://instagram.com/BloqVideo
 */

const LINKS = [
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/BloqVideo",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
        <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.22 8h4.56v14H.22V8zm7.39 0h4.37v1.92h.06c.61-1.16 2.1-2.38 4.32-2.38 4.62 0 5.47 3.04 5.47 6.99V22h-4.56v-6.16c0-1.47-.03-3.36-2.05-3.36-2.05 0-2.37 1.6-2.37 3.26V22H7.61V8z"/>
      </svg>
    ),
  },
  {
    name: "X",
    href: "https://x.com/BloqVideo",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
        <path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.844l-5.36-7.013L4.667 22H1.41l8.02-9.166L1 2h7.012l4.84 6.4L18.244 2zm-1.2 18h1.83L7.04 4H5.08l11.964 16z"/>
      </svg>
    ),
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/BloqVideo",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
        <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"/>
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://instagram.com/BloqVideo",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.336 3.608 1.311.975.975 1.249 2.242 1.311 3.608.058 1.266.069 1.646.069 4.85s-.012 3.584-.07 4.85c-.062 1.366-.336 2.633-1.311 3.608-.975.975-2.242 1.249-3.608 1.311-1.266.058-1.646.069-4.85.069s-3.584-.012-4.85-.07c-1.366-.062-2.633-.336-3.608-1.311-.975-.975-1.249-2.242-1.311-3.608C2.175 15.747 2.163 15.367 2.163 12s.012-3.584.07-4.85c.062-1.366.336-2.633 1.311-3.608.975-.975 2.242-1.249 3.608-1.311C8.416 2.175 8.796 2.163 12 2.163zm0 1.802c-3.141 0-3.515.011-4.756.068-1.024.047-1.58.218-1.95.362-.49.19-.84.418-1.207.785-.367.367-.595.717-.785 1.207-.144.37-.315.926-.362 1.95-.057 1.241-.068 1.615-.068 4.756s.011 3.515.068 4.756c.047 1.024.218 1.58.362 1.95.19.49.418.84.785 1.207.367.367.717.595 1.207.785.37.144.926.315 1.95.362 1.241.057 1.615.068 4.756.068s3.515-.011 4.756-.068c1.024-.047 1.58-.218 1.95-.362.49-.19.84-.418 1.207-.785.367-.367.595-.717.785-1.207.144-.37.315-.926.362-1.95.057-1.241.068-1.615.068-4.756s-.011-3.515-.068-4.756c-.047-1.024-.218-1.58-.362-1.95-.19-.49-.418-.84-.785-1.207-.367-.367-.717-.595-1.207-.785-.37-.144-.926-.315-1.95-.362-1.241-.057-1.615-.068-4.756-.068zm0 3.063A4.972 4.972 0 0 1 16.972 12 4.972 4.972 0 0 1 12 16.972 4.972 4.972 0 0 1 7.028 12 4.972 4.972 0 0 1 12 7.028zm0 8.205A3.233 3.233 0 1 0 12 8.767a3.233 3.233 0 0 0 0 6.466zm6.338-8.41a1.161 1.161 0 1 1-2.323 0 1.161 1.161 0 0 1 2.323 0z"/>
      </svg>
    ),
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@BloqVideo",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" aria-hidden="true">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.546 15.568V8.432L15.818 12l-6.272 3.568z"/>
      </svg>
    ),
  },
];

export default function SocialLinks({ tone = "dark", className = "" }) {
  // tone="dark" → semi-transparent icons over a dark background (footer)
  // tone="light" → solid teal circles with white icons (Contact page, nav, etc.)
  const isLight = tone === "light";
  const itemClass = isLight
    ? "bg-[#005e7a] text-white hover:bg-[#00475c]"
    : "text-white/60 hover:text-white border border-current/20";
  return (
    <ul
      className={`flex items-center gap-3 ${className}`}
      aria-label="Bloq social media"
      data-testid="social-links"
    >
      {LINKS.map((s) => (
        <li key={s.name}>
          <a
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Bloq on ${s.name}`}
            data-testid={`social-${s.name.toLowerCase()}`}
            className={`inline-flex items-center justify-center w-8 h-8 rounded-full transition-colors ${itemClass}`}
            style={{ borderRadius: 9999 }}
          >
            {s.icon}
          </a>
        </li>
      ))}
    </ul>
  );
}
